import React, { Component } from 'react'

const SPECIAL_LABELS = new Set([
  'New Screen...',
  'New Feature...',
  'Back',
  'Website...',
])

class ScreenSearchInput extends Component {
  constructor(props) {
    super(props)
    this.state = { value: '' }
    this.inputRef = React.createRef()
  }

  componentDidMount() {
    const input = this.inputRef.current

    if (input) {
      setTimeout(() => input.focus(), 0)
    }
  }

  handleChange = e => {
    const { value } = e.target
    this.setState({ value })
    this.filterItems(value)
  }

  filterItems = query => {
    const input = this.inputRef.current
    const container = input?.closest('.multi-menu-scroll-container')

    if (!container) return

    const normalizedQuery = query.toLowerCase().trim()
    const children = Array.from(container.children)

    children.forEach(child => {
      // Skip the search item itself (first child)
      if (child.contains(input)) return

      const isSpacer = child.classList.contains('multi-menu-spacer')

      if (isSpacer) {
        // Temporarily show all spacers; we'll clean up below
        child.style.display = ''

        return
      }

      const labelEl = child.querySelector('.multi-menu-item-label-text')
      const label = labelEl?.textContent || ''
      const isSpecial = SPECIAL_LABELS.has(label)

      if (
        !normalizedQuery ||
        isSpecial ||
        label.toLowerCase().includes(normalizedQuery)
      ) {
        child.style.display = ''
      } else {
        child.style.display = 'none'
      }
    })

    // Clean up spacers: hide spacers that are adjacent to other
    // spacers or at the very end
    let prevWasSpacer = true

    children.forEach(child => {
      if (child.contains(input)) {
        prevWasSpacer = true

        return
      }

      if (child.style.display === 'none') return

      const isSpacer = child.classList.contains('multi-menu-spacer')

      if (isSpacer && prevWasSpacer) {
        child.style.display = 'none'
      }

      if (isSpacer) {
        prevWasSpacer = true
      } else {
        prevWasSpacer = false
      }
    })

    // Hide trailing spacer
    for (let i = children.length - 1; i >= 0; i -= 1) {
      const child = children[i]

      if (child.style.display === 'none') continue
      if (child.classList.contains('multi-menu-spacer')) {
        child.style.display = 'none'
      }

      break
    }
  }

  handleMouseDown = e => {
    e.stopPropagation()
  }

  handleClick = e => {
    e.stopPropagation()
  }

  handleKeyDown = e => {
    e.stopPropagation()
  }

  render() {
    const { value } = this.state

    return (
      <input
        ref={this.inputRef}
        type="text"
        value={value}
        onChange={this.handleChange}
        onMouseDown={this.handleMouseDown}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        placeholder="Search screens..."
        className="screen-search-input"
      />
    )
  }
}

export default ScreenSearchInput
